var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("breadcrumb", { staticClass: "breadcrumb-container" }),
      _vm._v(" "),
      _c("Cti", { ref: "ctiRef" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "全屏",
                      effect: "dark",
                      placement: "bottom"
                    }
                  },
                  [_c("screenfull", { staticClass: "right-menu-item" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "布局大小",
                      effect: "dark",
                      placement: "bottom"
                    }
                  },
                  [_c("size-select", { staticClass: "right-menu-item" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "通知中心",
                      effect: "dark",
                      placement: "bottom"
                    }
                  },
                  [_c("notice", { staticClass: "right-menu-item" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "下载中心",
                      effect: "dark",
                      placement: "bottom"
                    }
                  },
                  [_c("Download", { staticClass: "right-menu-item" })],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { staticClass: "avatar-container", attrs: { trigger: "click" } },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c(
                  "span",
                  { staticStyle: { color: "#40444D", "font-weight": "500" } },
                  [_vm._v(_vm._s(_vm.user.name))]
                ),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [_c("el-dropdown-item", [_vm._v("首页")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleChangePwd($event)
                        }
                      }
                    },
                    [_vm._v("\n          密码修改\n        ")]
                  ),
                  _vm._v(" "),
                  _c("el-dropdown-item", { attrs: { divided: "" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "block" },
                        on: { click: _vm.logout }
                      },
                      [_vm._v("退出")]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("password", { ref: "password" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }